document.addEventListener('DOMContentLoaded', () => {
  const pageSize = 3;
  let currentPage = 1;

  const pressReleasesGrid = document.getElementById('press-releases-grid');
  const pressReleaseItems = Array.from(
    document.querySelectorAll('.done-section-press-article-anchor')
  );
  const paginationControls = document.getElementById('pagination-controls');

  const getVisibleItems = (items) => (pageSize) => (currentPage) =>
    items.map((item, index) => ({
      item,
      visible:
        index >= (currentPage - 1) * pageSize && index < currentPage * pageSize
    }));

  const updateItemDisplay = (itemsWithVisibility) =>
    itemsWithVisibility.forEach(({ item, visible }) => {
      item.style.display = visible ? 'block' : 'none';
    });

  const generatePaginationControls = (totalPages) => (currentPage) => ({
    previous: currentPage > 1 ? currentPage - 1 : null,
    next: currentPage < totalPages ? currentPage + 1 : null,
    pages: Array.from({ length: totalPages }, (_, i) => ({
      page: i + 1,
      isActive: i + 1 === currentPage
    }))
  });

  const renderControls =
    (paginationControls) => (controls) => (onPageChange) => {
      paginationControls.innerHTML = '';

      const { previous, next, pages } = controls;

      if (previous !== null) {
        const prevButton = document.createElement('button');
        prevButton.classList.add('pagination-prev');
        prevButton.setAttribute('aria-label', 'page précédente');
        prevButton.innerHTML = `
          <svg id="arrowDownWithout" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.092 38.828">
            <g fill="currentColor">
              <path d="M14.046 38.828 7.024 26.664 0 14.501l14.046 3.836L28.092 14.5l-7.024 12.163Z"/>
              <path d="M9.813 0h8.467l-1.449 22.519h-5.57Z"/>
            </g>
          </svg>`;
        prevButton.addEventListener('click', () => onPageChange(previous));
        paginationControls.appendChild(prevButton);
      }

      pages.forEach(({ page, isActive }) => {
        const pageButton = document.createElement('button');
        pageButton.textContent = page;
        pageButton.classList.add(
          'pagination-number',
          isActive ? 'active' : 'innactive'
        );
        pageButton.addEventListener('click', () => onPageChange(page));
        paginationControls.appendChild(pageButton);
      });

      if (next !== null) {
        const nextButton = document.createElement('button');
        nextButton.classList.add('pagination-next');
        nextButton.setAttribute('aria-label', 'page suivante');
        nextButton.innerHTML = `
          <svg id="arrowDownWithout" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.092 38.828">
            <g fill="currentColor">
              <path d="M14.046 38.828 7.024 26.664 0 14.501l14.046 3.836L28.092 14.5l-7.024 12.163Z"/>
              <path d="M9.813 0h8.467l-1.449 22.519h-5.57Z"/>
            </g>
          </svg>`;
        nextButton.addEventListener('click', () => onPageChange(next));
        paginationControls.appendChild(nextButton);
      }
    };

  const render = (currentPage) => {
    const totalPages = Math.ceil(pressReleaseItems.length / pageSize);

    const visibleItems =
      getVisibleItems(pressReleaseItems)(pageSize)(currentPage);
    updateItemDisplay(visibleItems);

    const controls = generatePaginationControls(totalPages)(currentPage);
    renderControls(paginationControls)(controls)((newPage) => {
      currentPage = newPage;
      render(currentPage);
    });
  };

  render(currentPage);
});
